import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal, ProgressSteps } from "../..";
import { glyphs } from "../../../Styles";
import NewSectionModalLvl1 from "./newSectionModalLvl1";
import NewSectionModalLvl2 from "./newSectionModalLvl2";
import NewSectionModalLvl3 from "./newSectionModalLvl3";

interface NewSectionModal_Props {
  isModalOpen: boolean
  closeModal: () => void,
}

export interface Pen {
  id: string
  penId: string | null
  io: string | null
  feederOutput?: number | null
  waterOutput?: number | null
  activatorInput?: number | null
}

export interface Section {
  sectionNo: number,
  lanController: string,
  pens: Pen[];
  feeder?: boolean
  water?: boolean
  activator?: boolean
}

export default function NewSectionModal({isModalOpen, closeModal}:NewSectionModal_Props) {
  const {t} = useTranslation()
  const [currentSectionLevel, setCurrentSectionLevel] = useState(1);
  const [pens, setPens] = useState<Pen[]>([]);
  const [section, setSection] = useState<Section>({ pens: [], feeder: true, sectionNo: 1, lanController: "AICO_LAN1" });

  const handlePensChange = (updatedPens: Pen[]) => {
    const pensWithIO = updatedPens.map(pen => ({
      ...pen,
      io: pen.io ?? null, // Ensure io is always defined
    }));
    setPens(pensWithIO);
  };

  const handleSectionChange = (updatedSection: Section) => {
    setSection(updatedSection);
    console.log("updated section parent modal:", updatedSection)
  };

  // Function to handle Quick Entry Modal based on level
  const ShowQuickEntry = (level: 0 | 1 | 2 | 3) => {
    setCurrentSectionLevel(level);
  };

  // Reset state when modal opens
  useEffect(() => {
    if (isModalOpen) {
      setCurrentSectionLevel(1); // Reset to Main Info Modal
    }
  }, [isModalOpen]);

  // Function to handle "Go Back"
  const onGoBack = () => {
    if (currentSectionLevel === 3) {
      ShowQuickEntry(2); // Go back to Level 2
    } else if (currentSectionLevel === 2) {
      ShowQuickEntry(1); // Go back to Level 1
    } 
  }
    
  return (
    <Modal 
      isModalOpen={isModalOpen}
      overrides={{ 
        isPrimaryComponent: true 
      }}
      modalHeader={t("locationFeeder.newSectionPopup.newSection")}
      // modalSubHeader={`Section ${section.sectionNo}`} 
      onCloseBtn={closeModal}
      onGoBack={currentSectionLevel === 2 || currentSectionLevel === 3? onGoBack : undefined}
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "40px"}}>
        <ProgressSteps titles={[t("locationFeeder.newSectionPopup.layout"), t("locationFeeder.newSectionPopup.io"), t("locationFeeder.newSectionPopup.apply")]} icons={[glyphs.Animal({}), glyphs.Animal({}), glyphs.Animal({})]} opacityValues={currentSectionLevel === 1 ? [1, 0.5, 0.5] : currentSectionLevel === 2 ? [0.5, 1, 0.5] : [0.5, 0.5, 1] }/>
        
        {currentSectionLevel === 1 && <NewSectionModalLvl1 pens={pens} onPensChange={handlePensChange} onSectionChange={handleSectionChange}/>} {/* Select Modal */}
        {currentSectionLevel === 2 && <NewSectionModalLvl2 section={section} onSectionChange={handleSectionChange}/>} {/* Action Modal */}
        {currentSectionLevel === 3 && <NewSectionModalLvl3 section={section}/>} {/* View Modal */}
        
        <Button 
          content={currentSectionLevel === 1||currentSectionLevel === 2 ? t("buttons.next") : t("buttons.createBtn")}
          onClick={currentSectionLevel === 1 ? () => setCurrentSectionLevel(2) : currentSectionLevel === 2 ? () => setCurrentSectionLevel(3) : () => closeModal() } // TODO CTO: On closeModal() also save to db/create report
        />
      </div>
    </Modal>
  );
}